import { $ } from '@/Engine/state';
import { IV3D } from '@/Interfaces/v3d';
import { markAllCollision,  noMarkAllCollision } from '@/Engine/eventHandlers/libs/markCollision';
import { isCursorOutsideToolChest } from '@/Engine/eventHandlers/libs/isModelOutsideToolChest';
import { visibleOffForModel, visibleOnForModel } from '@/Engine/app';
import { useStoreUI } from '@/Store/storeUI';
import { Part } from '@/Engine/Part';
import { calculatePosition, calculatePositionX } from '@/Engine/eventHandlers/libs/calculatePositionComponents';
import { calculateScale } from '@/Engine/eventHandlers/libs/calculateScale';
import { getPointerCoords, setRaycasterFromCamera } from '@/Engine/eventHandlers/libs/raycaster';
import { animateDoors } from '@/Engine/eventHandlers/libs/animateDoors';
import { Vector3 } from 'three';
import { smallCasePrototypeIds } from '@/Constants/caseComponentsLib/caseComponentsLib';
import { chpuHardChangeModel } from '@/Engine/eventHandlers/libs/chpuCalculate';

declare let v3d: IV3D;


export const onPointerMoveHandler = async(e: PointerEvent) => {
    if (!$.isUpdateLoadModel) return;
    useStoreUI().setPointerPosition(e.clientX,e.clientY);
    setRaycasterFromCamera(e);
    //анимация заблокирована во время движения комплектующего вне шкафа
    // if (!$.selectedModel || $.selectedModel?.visible == true) animateDoors();
    if (!$.selectedModel || $.positionStartPointer === null || !$.toolChest || $.up || !$.down) return;
    $.app.controls.enableRotate = false;
    $.objWithoutWall = false;
    $.moved = true;
    $.up = false;
    $.down = true;
    let obj = $.selectedModel.userData.parent;
    obj.updObb();

    if ($.ctrlKey) {
        const newObj = $.toolChest.copy(obj);
        if (newObj) {
            newObj?.settingPart($.selectedModel.position, obj.isLeft, $.toolChest.colorFrame, $.toolChest.colorFace);
            obj.unselect();
            newObj.select();
            obj.updObb();
            obj = newObj;
        }
        $.ctrlKey = false;
    }

    noMarkAllCollision();
    if (obj?.isChangeChpuHard()) await chpuHardChangeModel();
    markAllCollision();

    const normPointer = getPointerCoords();
    if (!normPointer) return;

    isCursorOutsideToolChest() ? visibleOffForModel($.selectedModel) : visibleOnForModel($.selectedModel);

    //смещения
    const dx = normPointer.x - $.positionStartPointer.x;
    const dy = normPointer.y - $.positionStartPointer.y;
    $.pointerVirtual.set(dx + obj.positionStart.x, dy + obj.positionStart.y, 0);

    const oldPositionY = obj.position.y;
    const oldIsLeft = obj.scale.x;
    //позиционирование верх/низ + по Ox
    calculatePosition(obj);


    // малое комплектующее без перегородки
    const heightSeparator = $.toolChest.separatorT?.find(x => x.height)?.height ?? $.toolChest.separator?.find(x => x.height)?.height;
    if (isCaseWithoutSeparator(obj.prototypeId) &&
        ((heightSeparator && obj.getMaxPositionY() > heightSeparator) || !heightSeparator)) {
        obj.redMark();
        $.objWithoutWall = true;
    }
    if (obj.key.includes('separator') || obj.key.includes('accessory')) {
        $.render();
        return;
    }
    //смещение левая/правая сторона
    if (obj.isSmall) {
        calculateScale(obj);
    }
    moveAccessoryWithParent(obj, oldPositionY, oldIsLeft);
    $.render();
};


export function isCaseWithoutSeparator(casePrototypeId: string) {
    if (!$.toolChest) return false;
    if ($.toolChest.blenderName === 'tc_1947') return false;
    return smallCasePrototypeIds.includes(casePrototypeId);
}
export function moveAccessoryWithParent(obj: Part, oldPositionY: number, oldIsLeft: number) {
//при движении родителя двигать и потомов ЭКРАН + АКСЕССУАРЫ
    if (!obj.parentAccessory  || !obj.childrenAccessory?.length) {
        $.render();
        return;
    }
    const newPositionY = obj.position.y;
    const newIsLeft = obj.scale.x;
    let dif;
    obj.childrenAccessory.forEach((accessory: Part) => {
        dif = null;
        if (oldPositionY !== newPositionY) {
            dif = accessory.position.y - oldPositionY;
            accessory.position = new Vector3(accessory.position.x, newPositionY+dif, accessory.position.z);
        }

        if (oldIsLeft === newIsLeft) return;
        dif = accessory.position.x;
        dif += oldIsLeft > newIsLeft ? -obj.width : obj.width;
        calculatePositionX(accessory, dif);
    });
}